import React, { useState } from 'react';

import BlurPopup from 'components/BlurPopup';
import { Button } from 'components/Buttons/Button';
import { useAppSelector } from 'hooks/useAppSelector';
import { maskMonetaryValue } from 'utils/stringUtils';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { updateApplicationInStore } from 'utils/updateApplicationInStore';
import { updateRequiredInformation } from 'utils/updateRequiredInformation';
import { hilAutomatedOffersApi } from 'api/AutomatedOffersApi';

import styles from './OffersInformationPopup.module.scss';

interface OffersInformationPopupProps {
  maxLoanAmount: number;
}

const getBorrowerNames = (borrowerFirstName: string, coBorrowerFirstName?: string | null) => {
  return borrowerFirstName + (!!coBorrowerFirstName ? ` and ${coBorrowerFirstName}` : '');
};

const OffersInformationPopup = ({ maxLoanAmount }: OffersInformationPopupProps) => {
  const dispatch = useAppDispatch();

  const { applicationId, variables } = useAppSelector((state) => state.application);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isOpen, setIsOpen] = useState<boolean>(!variables?.accept_offer_pop_up_viewed);

  const handlePopupClose = async () => {
    try {
      setIsButtonLoading(true);

      const application = await hilAutomatedOffersApi.confirmOffersInformation({
        applicationId: applicationId!,
      });

      updateApplicationInStore(application, dispatch);
      updateRequiredInformation(application, dispatch);
    } finally {
      setIsButtonLoading(false);
      setIsOpen(false);
    }
  };

  return (
    <BlurPopup
      id="popup"
      classes={{
        paper: styles.paper,
        container: styles.container,
      }}
      onClose={() => {}}
      open={isOpen}
      scroll="body"
      blurDeep={2}
    >
      <>
        <div className={styles.headerText}>
          {getBorrowerNames(variables?.borrower_first_name!, variables?.coborrower_first_name)},
        </div>
        <div className={styles.messageContainer}>
          <a className={styles.message}>
            Great News! With qualifying offers up to {maskMonetaryValue(maxLoanAmount)}, you can include any additional
            home improvements that you want to finance. On the next page, fine tune your desired loan amount.
          </a>
        </div>
        <div className={styles.buttonsContainer}>
          <Button onClick={handlePopupClose} isLoading={isButtonLoading}>
            Got it
          </Button>
        </div>
      </>
    </BlurPopup>
  );
};

export default OffersInformationPopup;
